/* Saatchi Watch — homepage behaviour. Cart, search and quick view talk to the live Shopify store. */
(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const CFG = window.SW || {}, R = CFG.routes || {};
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const FINE = matchMedia('(hover:hover) and (pointer:fine)').matches;
const DESIGN = !!(window.Shopify && window.Shopify.designMode);
const isMob = () => matchMedia('(max-width: 900px)').matches;
const canAnim = () => !RM && !DESIGN;
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const root = () => { const r = R.root || '/'; return r.endsWith('/') ? r : r + '/'; };
const sized = (u, w) => { if (!u) return ''; if (u.startsWith('//')) u = 'https:' + u; return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };
const money = cents => {
  const n = Number(cents) / 100, fmt = CFG.moneyFormat || '${{amount}}';
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
    const comma = /comma_separator/.test(k), s = n.toFixed(/no_decimals/.test(k) ? 0 : 2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    return s.join(comma ? ',' : '.');
  });
};
const split = t => { const i = t.indexOf(' | '); if (i > -1) return [t.slice(0, i), t.slice(i + 3)]; const w = t.split(' '); return [w[0], w.slice(1).join(' ') || t]; };

function toast(msg) { const t = $('#toast'); if (!t) return; $('#toastMsg').textContent = msg; t.classList.add('on'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('on'), 2600); }
function overlay(node, on) {
  if (!node) return;
  node.classList.toggle('on', on); node.setAttribute('aria-hidden', on ? 'false' : 'true');
  const any = $$('.drawer.on, .qv.on').length > 0;
  $('#scrim').classList.toggle('on', any); document.body.style.overflow = any ? 'hidden' : '';
  if (on) setTimeout(() => node.querySelector('button, a, input')?.focus(), 60);
}
const closeAll = () => ['#cart', '#wish', '#qv'].forEach(s => overlay($(s), false));

/* 1. announcement */
function ann() {
  const bar = $('.ann'); if (!bar) return;
  const ul = $('.ann-rot ul', bar), items = $$('li', ul);
  if (items.length > 1) {
    ul.appendChild(items[0].cloneNode(true));
    let i = 0; const ms = +bar.dataset.rot || 4200;
    setInterval(() => {
      i++; const h = bar.offsetHeight || 38;
      ul.style.transition = 'transform .75s cubic-bezier(.22,1,.36,1)'; ul.style.transform = `translateY(${-i * h}px)`;
      if (i === items.length) setTimeout(() => { ul.style.transition = 'none'; i = 0; ul.style.transform = 'translateY(0)'; }, 780);
    }, ms);
  }
  const c = $('[data-clock]', bar);
  if (c) { const t = () => { c.textContent = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }) + ' — Local time'; }; t(); setInterval(t, 30000); }
}

/* 2. header, mega menu, drawer, search */
function header() {
  const hdr = $('#hdr'); if (!hdr) return;
  const mnav = $('#mnav'); let last = 0;
  const onScroll = () => {
    const y = scrollY, hero = $('.hero');
    hdr.classList.toggle('solid', !hero || y > 90);
    if (!mnav.classList.contains('open')) hdr.classList.toggle('hide', y > last && y > 340 && !$('.mega.open'));
    last = y;
  };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  let open = null, t;
  const set = k => {
    open = k;
    $$('.mega', hdr).forEach(m => m.classList.toggle('open', m.dataset.panel === k));
    $$('[data-mega]', hdr).forEach(li => { const on = li.dataset.mega === k; li.classList.toggle('open', on); $('button', li).setAttribute('aria-expanded', on); });
  };
  $$('[data-mega]', hdr).forEach(li => {
    const k = li.dataset.mega;
    li.addEventListener('mouseenter', () => { clearTimeout(t); set(k); });
    li.addEventListener('mouseleave', () => { t = setTimeout(() => set(null), 220); });
    $('button', li).addEventListener('click', e => { e.stopPropagation(); set(open === k ? null : k); });
  });
  $$('.mega', hdr).forEach(m => { m.addEventListener('mouseenter', () => clearTimeout(t)); m.addEventListener('mouseleave', () => { t = setTimeout(() => set(null), 220); }); });
  document.addEventListener('click', e => { if (!e.target.closest('.mega, .nav')) set(null); });

  const burger = $('#burger');
  const tm = on => {
    mnav.classList.toggle('open', on); burger.classList.toggle('on', on);
    burger.setAttribute('aria-expanded', on); mnav.setAttribute('aria-hidden', !on);
    document.body.style.overflow = on ? 'hidden' : ''; if (on) hdr.classList.remove('hide');
  };
  burger.addEventListener('click', () => tm(!mnav.classList.contains('open')));
  $('#mnavClose').addEventListener('click', () => tm(false));
  mnav.addEventListener('click', e => { if (e.target.closest('a')) tm(false); });

  const srch = $('#srch'), input = $('#srchInput'), res = $('#srchRes');
  const ts = on => { srch.classList.toggle('open', on); srch.setAttribute('aria-hidden', !on); document.body.style.overflow = on ? 'hidden' : ''; if (on) setTimeout(() => input.focus(), 120); };
  $('#btnSearch').addEventListener('click', () => ts(true));
  $('#srchClose').addEventListener('click', () => ts(false));
  addEventListener('keydown', e => { if (e.key === 'Escape') { set(null); ts(false); tm(false); closeAll(); } });
  let timer, ctrl;
  const run = async () => {
    const q = input.value.trim(); if (!q) { res.innerHTML = ''; return; }
    ctrl && ctrl.abort(); ctrl = new AbortController();
    try {
      const r = await fetch(`${R.suggest}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10`, { signal: ctrl.signal });
      const d = await r.json(), ps = (d.resources && d.resources.results && d.resources.results.products) || [];
      res.innerHTML = ps.length ? ps.map(p => {
        const [m, n] = split(p.title);
        return `<a href="${esc(p.url)}"><span class="thumb">${p.image ? `<img src="${esc(sized(p.image, 160))}" alt="" loading="lazy">` : ''}</span><span><b>${esc(n)}</b><span>${esc(m)} · ${money(Math.round(parseFloat(p.price) * 100))}</span></span></a>`;
      }).join('') : `<p class="mono" style="color:var(--muted)">No models match “${esc(q)}”.</p>`;
    } catch (e) { /* aborted */ }
  };
  input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 220); });
  $$('[data-q]', srch).forEach(b => b.addEventListener('click', () => { input.value = b.dataset.q; run(); }));
}

/* 3. hero slider */
function heroInit(h) {
  if (h._sw) return; h._sw = 1;
  const slides = $$('.slide', h), copies = $$('.s-copy', h), dots = $$('.h-dot', h);
  const ms = +h.dataset.interval || 6800, auto = h.dataset.autoplay !== 'false';
  let cur = 0, timer;
  const restart = () => { clearInterval(timer); if (auto && !RM && !DESIGN && slides.length > 1) timer = setInterval(() => go(cur + 1), ms); };
  const go = n => {
    cur = (n + slides.length) % slides.length;
    slides.forEach((s, i) => s.classList.toggle('on', i === cur));
    copies.forEach((c, i) => c.classList.toggle('on', i === cur));
    dots.forEach((d, i) => d.setAttribute('aria-current', i === cur));
    const now = $('[data-now]', h); if (now) now.textContent = String(cur + 1).padStart(2, '0');
    restart();
  };
  dots.forEach(d => d.addEventListener('click', () => go(+d.dataset.i)));
  $('[data-next]', h)?.addEventListener('click', () => go(cur + 1));
  $('[data-prev]', h)?.addEventListener('click', () => go(cur - 1));
  h.addEventListener('mouseenter', () => { clearInterval(timer); h.classList.add('paused'); });
  h.addEventListener('mouseleave', () => { h.classList.remove('paused'); restart(); });
  h.addEventListener('keydown', e => { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
  let x0 = null;
  const st = e => { x0 = (e.touches ? e.touches[0] : e).clientX; clearInterval(timer); };
  const en = e => { if (x0 == null) return; const dx = (e.changedTouches ? e.changedTouches[0] : e).clientX - x0; Math.abs(dx) > 48 ? go(cur + (dx < 0 ? 1 : -1)) : restart(); x0 = null; };
  h.addEventListener('touchstart', st, { passive: true }); h.addEventListener('touchend', en, { passive: true });
  h.addEventListener('pointerdown', e => { if (e.pointerType === 'mouse' && !e.target.closest('a,button')) st(e); });
  h.addEventListener('pointerup', e => { if (e.pointerType === 'mouse') en(e); });
  new IntersectionObserver(([e]) => e.isIntersecting ? restart() : clearInterval(timer), { threshold: .15 }).observe(h);
  h._go = i => go(i); restart();
}

/* rails */
function rail(r) {
  if (r._sw) return; r._sw = 1;
  const sec = r.closest('section') || document, prev = $('[data-rprev]', sec), next = $('[data-rnext]', sec), bar = $('[data-rbar]', sec);
  const step = () => (r.firstElementChild ? r.firstElementChild.getBoundingClientRect().width : 280) + 18;
  const upd = () => {
    const max = r.scrollWidth - r.clientWidth;
    if (prev) prev.disabled = r.scrollLeft < 4; if (next) next.disabled = r.scrollLeft > max - 4;
    if (bar) bar.style.transform = `scaleX(${max > 0 ? Math.min(1, Math.max(.06, r.scrollLeft / max)) : 1})`;
  };
  prev?.addEventListener('click', () => r.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
  next?.addEventListener('click', () => r.scrollBy({ left: step() * 2, behavior: 'smooth' }));
  r.addEventListener('scroll', upd, { passive: true }); new ResizeObserver(upd).observe(r); upd();
  let down = false, sx = 0, sl = 0, moved = 0;
  r.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.target.closest('button,a')) return; down = true; moved = 0; sx = e.clientX; sl = r.scrollLeft; r.classList.add('drag'); });
  addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; moved = Math.abs(dx); r.scrollLeft = sl - dx; }, { passive: true });
  addEventListener('pointerup', () => { if (down) { down = false; r.classList.remove('drag'); } });
  r.addEventListener('click', e => { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
}

/* spotlight gallery */
function spot(s) {
  if (s._sw) return; s._sw = 1;
  const main = $('[data-spot-main] img', s), btns = $$('.spot-thumbs button', s);
  btns.forEach(b => b.addEventListener('click', () => { if (main) { main.removeAttribute('srcset'); main.src = b.dataset.src; } btns.forEach(x => x.setAttribute('aria-current', x === b)); }));
}

/* cart (Shopify AJAX API) */
async function refreshCart() { try { const r = await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }); paintCart(await r.json()); } catch (e) {} }
function paintCart(c) {
  const n = c.item_count, b = $('#cartBadge');
  if (b) { b.textContent = n; b.classList.toggle('on', n > 0); }
  $('#cartCount').textContent = `(${n})`; $('#cartTotal').textContent = money(c.total_price);
  $('#cartBody').innerHTML = n ? c.items.map(it => {
    const [m, nm] = split(it.product_title);
    return `<div class="ci"><span class="t">${it.image ? `<img src="${esc(sized(it.image, 160))}" alt="" loading="lazy">` : ''}</span><span><b><a href="${esc(it.url)}">${esc(nm)}</a></b><span>${esc(m)} · ${money(it.final_price)} × ${it.quantity}</span></span><button class="rm" type="button" data-rm="${esc(it.key)}">Remove</button></div>`;
  }).join('') : '<div class="empty"><svg viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9.2 8V6.4a2.8 2.8 0 0 1 5.6 0V8"/></svg><p>Your cart is empty.</p></div>';
  const co = $('#cartCheckout'); if (co) co.disabled = n === 0;
}
async function addToCart(id, btn) {
  if (!id) return; if (btn) btn.disabled = true;
  try {
    const r = await fetch(R.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) });
    const d = await r.json();
    if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
    await refreshCart();
    const it = d.items && d.items[0]; toast(`${it ? split(it.product_title)[0] : 'Watch'} added to cart`);
    const b = $('#cartBadge'); b.classList.add('pop'); setTimeout(() => b.classList.remove('pop'), 520);
  } catch (e) { toast(e.message); } finally { if (btn) btn.disabled = false; }
}
async function changeLine(key, q) {
  try { const r = await fetch(R.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) }); paintCart(await r.json()); } catch (e) {}
}

/* wishlist — stored on this device */
const WK = 'sw-wish';
const wl = () => { try { return JSON.parse(localStorage.getItem(WK)) || []; } catch (e) { return []; } };
const wsave = a => { try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} };
function paintWish() {
  const a = wl(), b = $('#wishBadge'); if (!b) return;
  b.textContent = a.length; b.classList.toggle('on', a.length > 0); $('#wishCount').textContent = `(${a.length})`;
  $('#wishBody').innerHTML = a.length ? a.map(p => `<div class="ci"><span class="t">${p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy">` : ''}</span><span><b><a href="${esc(p.u)}">${esc(p.t)}</a></b><span>${esc(p.m)} · ${esc(p.p)}</span></span><button class="rm" type="button" data-unwish="${esc(p.h)}">Remove</button></div>`).join('')
    : '<div class="empty"><svg viewBox="0 0 24 24"><path d="M12 20s-7.2-4.5-7.2-9.4A4.1 4.1 0 0 1 12 8.2a4.1 4.1 0 0 1 7.2 2.4C19.2 15.5 12 20 12 20Z"/></svg><p>Nothing saved yet.</p></div>';
  const hs = new Set(a.map(p => p.h));
  $$('[data-wish]').forEach(x => { const on = hs.has(x.dataset.wish); x.classList.toggle('on', on); x.setAttribute('aria-pressed', on); });
}
function toggleWish(b) {
  const a = wl(), h = b.dataset.wish, i = a.findIndex(p => p.h === h);
  if (i > -1) a.splice(i, 1); else a.unshift({ h, t: b.dataset.t, m: b.dataset.m, p: b.dataset.p, i: b.dataset.i, u: b.dataset.u });
  wsave(a); paintWish(); toast(i > -1 ? 'Removed from wishlist' : 'Saved to wishlist');
}

/* quick view — reads the live product JSON and its spec table */
const KEYS = ['Case size (L× W× H)', 'Weight', 'Water resistance', 'Construction', 'Case and bezel material', 'Band', 'Power supply and battery life', 'Glass'];
const STOP = new Set([...KEYS, 'Basic Information', 'Exterior', 'Watch Features', 'Time adjustment', 'Sensor feature', 'Light', 'Light color', 'Accuracy', 'Compatible band size', 'Other features', 'Calendar', 'Stopwatch', 'Timer', 'World time', 'Run time', 'Mute feature', 'Energy saving feature', 'Battery display/alert', 'Alarm/hourly time signal']);
function specs(html) {
  const d = document.createElement('div'); d.innerHTML = html || '';
  const ps = $$('p', d).map(p => p.textContent.trim()).filter(Boolean), out = [];
  KEYS.forEach(k => {
    const i = ps.indexOf(k); if (i < 0) return;
    const v = []; let j = i + 1;
    while (j < ps.length && v.length < 2 && !STOP.has(ps[j])) { if (!/^icon-question/.test(ps[j])) v.push(ps[j]); j++; }
    if (v.length) out.push([k.replace(' (L× W× H)', ''), v.join(' · ')]);
  });
  return out;
}
async function openQV(h) {
  let p; try { p = await (await fetch(`${root()}products/${h}.js`)).json(); } catch (e) { return; }
  const [m, n] = split(p.title), imgs = (p.images || []).slice(0, 6), v = p.variants.find(x => x.available) || p.variants[0];
  let idx = 0;
  const paint = () => { $('#qvImgWrap').innerHTML = imgs[idx] ? `<img src="${esc(sized(imgs[idx], 900))}" alt="${esc(p.title)}">` : ''; $$('#qvThumbs button').forEach((b, i) => b.setAttribute('aria-current', i === idx)); };
  $('#qvThumbs').innerHTML = imgs.length > 1 ? imgs.map((s, i) => `<button type="button" aria-label="Image ${i + 1}"><img src="${esc(sized(s, 120))}" alt=""></button>`).join('') : '';
  const sp = specs(p.description);
  $('#qvBody').innerHTML = `<span class="eyebrow no-rule">${esc((p.tags || []).join(' · '))}</span>
    <h2 class="h-s" id="qvTitle">${esc(n)}</h2>
    <p class="mono" style="color:var(--muted)">${esc(m)}${v && v.sku ? ' · SKU ' + esc(v.sku) : ''}</p>
    <div class="pc-foot"><span class="price" style="font-size:22px">${money(p.price)}${p.compare_at_price > p.price ? `<span class="was">${money(p.compare_at_price)}</span>` : ''}</span></div>
    ${sp.length ? `<dl class="qv-specs">${sp.map(([k, x]) => `<div><dt>${esc(k)}</dt><dd>${esc(x)}</dd></div>`).join('')}</dl>` : ''}
    <div class="s-cta"><button class="btn btn-solid" type="button" data-add="${v ? v.id : ''}"${p.available ? '' : ' disabled'}><span>${p.available ? 'Add to cart' : 'Sold out'}</span></button>
    <a class="btn btn-ghost" href="${esc(p.url || root() + 'products/' + p.handle)}"><span>Full details</span></a></div>`;
  paint(); $$('#qvThumbs button').forEach((b, i) => b.addEventListener('click', () => { idx = i; paint(); }));
  overlay($('#qv'), true);
}

function shop() {
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-add]'); if (a) { e.preventDefault(); if (!a.disabled) addToCart(a.dataset.add, a); return; }
    const q = e.target.closest('[data-qv]'); if (q) { e.preventDefault(); openQV(q.dataset.qv); return; }
    const w = e.target.closest('[data-wish]'); if (w) { e.preventDefault(); toggleWish(w); return; }
    const rm = e.target.closest('[data-rm]'); if (rm) { changeLine(rm.dataset.rm, 0); return; }
    const uw = e.target.closest('[data-unwish]'); if (uw) { wsave(wl().filter(p => p.h !== uw.dataset.unwish)); paintWish(); }
  });
  $('#btnCart')?.addEventListener('click', e => { e.preventDefault(); refreshCart(); overlay($('#cart'), true); });
  $('#btnWish')?.addEventListener('click', () => overlay($('#wish'), true));
  $$('[data-close]').forEach(b => b.addEventListener('click', closeAll));
  $('#scrim')?.addEventListener('click', closeAll);
  refreshCart(); paintWish();
}

/* animation layer */
function words(r) {
  if (!canAnim()) return;
  $$('[data-words]', r).forEach(h => {
    if (h.dataset.done) return; h.dataset.done = '1'; h.classList.add('words');
    h.innerHTML = h.textContent.trim().split(/\s+/).map((w, i) => `<span style="transition-delay:${i * 42}ms">${esc(w)}</span>`).join(' ');
  });
}
let io;
function countUp(n) {
  const to = parseFloat(n.dataset.count) || 0, pre = n.dataset.prefix || '', t0 = performance.now();
  const st = t => { const k = Math.min(1, (t - t0) / 1400), e = 1 - Math.pow(1 - k, 3); n.textContent = pre + Math.round(to * e).toLocaleString('en-US'); if (k < 1) requestAnimationFrame(st); };
  requestAnimationFrame(st);
}
function reveals(r) {
  const ts = $$('.rev-y, .rev-s, .stg, .words, .div-a, [data-count]', r);
  if (!canAnim()) { ts.forEach(t => t.classList.add('in')); return; }
  io = io || new IntersectionObserver(es => es.forEach(en => {
    if (!en.isIntersecting) return; en.target.classList.add('in');
    if (en.target.dataset.count) countUp(en.target); io.unobserve(en.target);
  }), { rootMargin: '0px 0px -12% 0px', threshold: .12 });
  ts.forEach(t => { if (t.dataset.count) t.textContent = (t.dataset.prefix || '') + '0'; io.observe(t); });
}
function parallax() {
  if (!canAnim()) return;
  let items = [];
  const collect = () => {
    const l = isMob();
    items = [...$$('.edi-media img').map(n => ({ n, k: l ? .05 : .13 })), ...$$('.split-media img').map(n => ({ n, k: l ? .04 : .1 })),
      ...$$('.story-frame img').map(n => ({ n, k: l ? .04 : .09 })), ...$$('.cats-bg img').map(n => ({ n, k: l ? .03 : .09 })),
      ...$$('[data-float]').map(n => ({ n, k: (+n.dataset.float / 100) * (l ? .4 : 1) }))];
  };
  collect(); let tk = false;
  const run = () => {
    const vh = innerHeight;
    items.forEach(({ n, k }) => { const r = n.getBoundingClientRect(); if (r.bottom < -200 || r.top > vh + 200) return; const p = (r.top + r.height / 2 - vh / 2) / vh; n.style.transform = `translate3d(0,${(-p * k * 100).toFixed(2)}px,0)`; });
    tk = false;
  };
  addEventListener('scroll', () => { if (!tk) { tk = true; requestAnimationFrame(run); } }, { passive: true });
  addEventListener('resize', () => { collect(); run(); }); run();
}
function progress() {
  const bar = $('#pbar'); if (!bar) return;
  const run = () => { const max = document.documentElement.scrollHeight - innerHeight; bar.style.transform = `scaleX(${max > 0 ? scrollY / max : 0})`; };
  addEventListener('scroll', run, { passive: true }); run();
}
function pointer() {
  if (!FINE || !canAnim()) return;
  $$('[data-magnet]').forEach(b => {
    b.addEventListener('pointermove', e => { const r = b.getBoundingClientRect(); b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .28}px, ${(e.clientY - r.top - r.height / 2) * .32}px)`; });
    b.addEventListener('pointerleave', () => { b.style.transform = ''; });
  });
  const dot = $('#cur'), ring = $('#curR'); if (!dot || !ring) return;
  let x = innerWidth / 2, y = innerHeight / 2, rx = x, ry = y;
  addEventListener('pointermove', e => {
    x = e.clientX; y = e.clientY; dot.classList.add('on'); ring.classList.add('on');
    dot.style.transform = `translate(${x}px,${y}px) translate(-50%,-50%)`;
    const t = e.target;
    ring.classList.toggle('big', !!t.closest('a,button,.pcard,.cat,.look,.gram-grid a'));
    ring.classList.toggle('drag-c', !!t.closest('[data-drag]') && !t.closest('button,a'));
  }, { passive: true });
  document.addEventListener('pointerleave', () => { dot.classList.remove('on'); ring.classList.remove('on'); });
  (function loop() { rx += (x - rx) * .16; ry += (y - ry) * .16; ring.style.transform = `translate(${rx}px,${ry}px) translate(-50%,-50%)`; requestAnimationFrame(loop); })();
}
function tilt() {
  if (!canAnim() || !FINE) return;
  $$('[data-tilt]').forEach(n => {
    const host = n.closest('.spot-stage') || n;
    host.addEventListener('pointermove', e => { const r = host.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5; n.style.transform = `perspective(900px) rotateY(${px * 11}deg) rotateX(${-py * 11}deg) translateZ(14px)`; });
    host.addEventListener('pointerleave', () => { n.style.transform = ''; });
  });
}
function anchors() {
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="#"]'); if (!a || a.target === '_blank') return;
    const u = new URL(a.href, location.href);
    if (u.origin !== location.origin || u.pathname !== location.pathname || u.hash.length < 2) return;
    const t = document.getElementById(decodeURIComponent(u.hash.slice(1))); if (!t) return;
    e.preventDefault();
    const off = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hdr-h')) || 76;
    scrollTo({ top: t.getBoundingClientRect().top + scrollY - off - 8, behavior: RM ? 'auto' : 'smooth' });
    history.replaceState(null, '', u.hash);
  });
}
function loc() { const f = $('#swLoc'); if (f) $$('select', f).forEach(s => s.addEventListener('change', () => f.submit())); }

function initSection(r) { $$('[data-hero]', r).forEach(heroInit); $$('[data-rail]', r).forEach(rail); $$('.spot', r).forEach(spot); words(r); reveals(r); paintWish(); }
document.addEventListener('shopify:section:load', e => initSection(e.target));
document.addEventListener('shopify:block:select', e => {
  const h = e.target.closest('[data-hero]'); if (!h || !h._go) return;
  const i = $$('.slide', h).indexOf(e.target); if (i > -1) h._go(i);
});
function init() {
  ann(); header(); initSection(document); shop(); parallax(); progress(); pointer(); tilt(); anchors(); loc();
  if (!RM) document.documentElement.classList.add('has-smooth');
}
document.readyState === 'loading' ? addEventListener('DOMContentLoaded', init) : init();
})();